import { useEffect, useState } from "react"

const InputQuantity = ({ max = 10, onChange, defaultValue = 1 }) => {
    const [current, setCurrent] = useState(defaultValue)
    const [inputValue, setInputValue] = useState(String(defaultValue))

    useEffect(() => {
        const safeValue = Math.max(1, Math.min(max, Number(defaultValue) || 1))
        setCurrent(safeValue)
        setInputValue(String(safeValue))
    }, [defaultValue, max])

    const minus = () => {
        if (current > 1) {
            const newVal = current - 1;
            setCurrent(newVal);
            setInputValue(newVal.toString());
            onChange(newVal);
        }
    }

    const plus = () => {
        if (current < max) {
            const newVal = current + 1;
            setCurrent(newVal);
            setInputValue(newVal.toString());
            onChange(newVal);
        }
    }

    return (
        <div className="flex items-center w-fit border-white border-[1px]">
            <button className="flex justify-center items-center border-r-[1px] border-r-white w-5 h-5" onClick={minus}>
                <img src="/assets/icons/icon-arrow-left.svg" alt="minus" />
            </button>

            <input
                type="number"
                className="bg-transparent text-white text-xs px-2 w-12 text-center"
                value={inputValue}
                onChange={(e) => {
                    const val = e.target.value;
                    setInputValue(val);
                    if (val !== '') {
                        const num = parseInt(val);
                        if (!isNaN(num)) {
                            setCurrent(num);
                            onChange(num);
                        }
                    }
                }}
                onBlur={() => {
                    const value = parseInt(inputValue) || 1;
                    const clamped = Math.max(1, Math.min(max, value));
                    setCurrent(clamped);
                    setInputValue(clamped.toString());
                    onChange(clamped);
                }}
                min={1}
                max={max}
            />

            <button className="flex justify-center items-center border-l-[1px] border-l-white w-5 h-5" onClick={plus}>
                <img src="/assets/icons/icon-arrow-right.svg" alt="plus" />
            </button>
        </div>
    )
}

export default InputQuantity